import { Divider, Flex, Typography } from 'antd';

import type { SectionTitleProps } from '@/UI/StepsForm/types';

const SectionTitle = ({
  title,
  description,
  icon,
  level = 4,
  divider = false,
  extra,
}: SectionTitleProps) => (
  <Flex vertical gap={0}>
    <Flex align="center" justify="space-between">
      <Flex align="center">
        {icon != null && icon}
        <Typography.Title level={level}>{title}</Typography.Title>
      </Flex>
      {extra}
    </Flex>
    {description != null && (
      <Typography.Text type="secondary">{description}</Typography.Text>
    )}
    {divider && <Divider size="small" />}
  </Flex>
);

export default SectionTitle;
